import cx from 'classnames'
import React from 'react'

import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

import { useClientOnly } from '@f-fertighaus/components/ClientOnly/ClientOnly'

const MobileMenuItem = ({
  menuItem,
  isOpen,
  postcode,
  onTopHeaderClick,
  onSubMenuClick,
  activeMenuType
}) => {
  const isMounted = useClientOnly()
  const composeNavigationURL = (menuItemUrl, additionalParams = []) => {
    let navigationURL = isMounted
      ? new URL(`${location.origin}${menuItemUrl}`)
      : menuItemUrl
    if (
      isMounted &&
      postcode &&
      /suche|anbieter/.test(menuItemUrl) &&
      !navigationURL.searchParams.has('delivery_regions__in')
    ) {
      navigationURL.searchParams.append('delivery_regions__in', postcode)
    }

    if (additionalParams.length > 0) {
      additionalParams.forEach(param => {
        if (isMounted) {
          navigationURL.searchParams.append(param.key, param.value)
        } else {
          navigationURL += `&${param.key}=${param.value}`
        }
      })
    }

    return navigationURL
  }

  return (
    <li className={`f-m-h-030 f-c-bo-neu050 PageHeader-menu-mobile-item`}>
      <CTA
        tag='a'
        href={composeNavigationURL(menuItem.url).toString()}
        type='text-primary'
        className={cx(
          '[ f-t-tminor f-p-v-020 f-pos-rel ] is-block',
          menuItem.active && 'is-active'
        )}
        onClick={onTopHeaderClick}
        wtData={{
          'CTA-click': {
            location: 'header'
          }
        }}>
        {menuItem.title}
        {menuItem.sub_menu_items && (
          <Icon
            icon='down-link-16px'
            className={cx(
              'f-icon-020',
              'f-c-st-inherit',
              'PageHeader-menu-toggle-icon',
              { 'is-open': isOpen }
            )}
          />
        )}
      </CTA>
      {menuItem.type === 'house-list' && isOpen && (
        <ul className='[ f-!list ]'>
          {menuItem.sub_menu_items.map((subMenuItem, index, arr) => {
            return (
              <li key={`sub_menu_link_${subMenuItem.title}`}>
                <CTA
                  tag='a'
                  type='text-primary'
                  className={cx(
                    '[ f-t-body f-t-ellip ] is-block',
                    arr.length !== index + 1 && 'f-m-b-020'
                  )}
                  href={composeNavigationURL(
                    subMenuItem.url,
                    subMenuItem.title === 'Grundrisse'
                      ? [{ key: 'has_floor_plans', value: true }]
                      : []
                  ).toString()}
                  onClick={onSubMenuClick}
                  wtData={{
                    'CTA-click': {
                      location: 'header',
                      label: subMenuItem.tracking_id
                    }
                  }}>
                  {subMenuItem.title}
                </CTA>
              </li>
            )
          })}
        </ul>
      )}
      {menuItem.type !== 'house-list' &&
        menuItem.type === activeMenuType &&
        isOpen &&
        menuItem.sub_menu_items.map(subMenuItem => {
          return (
            <ul
              key={`sub_menu_item_${subMenuItem.label || subMenuItem.title}`}
              className='[ f-!list ]'>
              <li>
                {subMenuItem.url ? (
                  <CTA
                    tag='a'
                    type='text-primary'
                    className={cx(
                      'f-t-tbody f-pos-rel f-t-ellip PageHeader-sub-menu-header is-block',
                      subMenuItem.sub_menu_links && 'f-m-b-020'
                    )}
                    href={subMenuItem.url}
                    wtData={{
                      'CTA-click': {
                        location: 'header'
                      }
                    }}>
                    {subMenuItem.label}
                  </CTA>
                ) : (
                  <div
                    className={cx(
                      'f-c-fo-pri f-t-tbody',
                      subMenuItem.sub_menu_links && 'f-m-b-020'
                    )}>
                    {subMenuItem.label}
                  </div>
                )}
                {subMenuItem.sub_menu_links && (
                  <ul className='f-!list f-d-flc f-fl-gap-020 f-p-l-020'>
                    {subMenuItem.sub_menu_links?.map(subMenuLink => (
                      <li key={`sub_menu_link_${subMenuLink.label}`}>
                        <CTA
                          tag='a'
                          type='text-primary'
                          className='[ f-t-body f-p-v-005 f-t-ellip ] is-block'
                          href={subMenuLink.url}
                          onClick={onSubMenuClick}
                          wtData={{
                            'CTA-click': {
                              location: 'header'
                            }
                          }}>
                          {subMenuLink.label}
                        </CTA>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            </ul>
          )
        })}
    </li>
  )
}

export default MobileMenuItem
